import { all, fork } from 'redux-saga/effects';
import { default as mainSaga } from './mainSaga';

export function* declarationsSagas() {
  yield all([mainSaga].map(fork));
}
